import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import FnrInput2 from "UI/FnrInput2";
import { colors } from "UI/colors";

ItemInfoNumberInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

export default function ItemInfoNumberInput({
  id,
  label,
  disabled,
  children,
  ...rest
}) {
  return (
    <>
      <LabeledNumberInputContainer>
        <label htmlFor={id}>
          {label}
          {children && <HelperText>{children}</HelperText>}
        </label>
        <NumberInput type="number" id={id} disabled={disabled} {...rest} />
      </LabeledNumberInputContainer>
    </>
  );
}

const LabeledNumberInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  color: #15436a;
`;

const NumberInput = styled(FnrInput2)`
  width: 6rem;
  margin-left: 1rem;
  color: #15436a;
`;

const HelperText = styled.div`
  margin-top: 0.3rem;
  font-size: 15px;
  font-weight: 400;
  color: ${colors.fnGray600};
`;
